import { useLayoutEffect, useState } from 'react'

type Props = {
  width: number
  height: number
}

const measure = () => ({
  width: window.innerWidth,
  height: window.innerHeight,
})

/**
 * You can listen on window size dimensions
 * its also possible to not use these, then response will be the last known dimensions
 */
export function useWindowSize(isSilent = false) {
  const [size, setSize] = useState<Props>(measure())

  useLayoutEffect(() => {
    if (isSilent) {
      setSize(measure())
      return () => {}
    }

    let timer: number | undefined

    const handleResize = () => {
      if (timer) {
        clearTimeout(timer)
      }

      timer = window.setTimeout(() => {
        setSize(measure())
      }, 64)
    }

    window.addEventListener('resize', handleResize)
    window.visualViewport?.addEventListener('resize', handleResize)

    return () => {
      if (timer) {
        clearTimeout(timer)
      }
      window.removeEventListener('resize', handleResize)
      window.visualViewport?.removeEventListener('resize', handleResize)
    }
  }, [isSilent])

  return size
}
